import { render } from "./FireRosterDetailPage.vue?vue&type=template&id=396035a8&scoped=true"
import script from "./FireRosterDetailPage.vue?vue&type=script&lang=ts"
export * from "./FireRosterDetailPage.vue?vue&type=script&lang=ts"

import "./FireRosterDetailPage.vue?vue&type=style&index=0&id=396035a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-396035a8"

export default script